const tab_sections = {
    identity: 'Identità',
    integrations: 'Connessioni',
    login_security: 'Accesso e sicurezza',
    permissions: 'Autorizzazioni',
    automation: 'Automazione',
    platform: 'Piattaforma',
    overview: 'Panoramica',
    authentication: 'Autenticazione',
    authorization: 'Autorizzazione',
    users: 'Utenti',
    developer: 'Sviluppatore',
    tenant: 'Inquilino',
};
export default Object.freeze(tab_sections);
